<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="">线索</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">线索详情</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="detailContent">
            <div class="upperInfoContent">
                <div class="title">
                    <span><span v-if="cluedeatil.niche_name">{{cluedeatil.niche_name}}</span>
                    <span v-else>--</span></span>
                    <div>未跟进</div>
                </div>

                <div class="back-btn">
                    <a-button @click="back">返回</a-button>
                    <!-- <a-button-group>
                        <a-button icon="left" />
                        <a-button icon="right" />
                    </a-button-group> -->
                </div>

                <div class="fieldContainer">
                    <!-- <div class="fieldItem">
                        <span>手机：</span>
                        <span v-if="cluedeatil.mobile_phone"><a href="javascript:;">{{cluedeatil.mobile_phone}}</a></span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>公司名称：</span>
                        <span v-if="cluedeatil.company_name">{{cluedeatil.company_name}}</span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>地址：</span>
                        <span v-if="cluedeatil.address">{{cluedeatil.address}}</span>
                        <span v-else>--</span>  -->
                    <!-- </div> -->
                    <div class="fieldItem">
                        <span>最近跟进时间：</span>
                        <span v-if="cluedeatil.last_follow_time">{{cluedeatil.last_follow_time}}</span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <!-- <div class="fieldItem">
                        <span>预计掉保时间：</span>
                        <span v-if="cluedeatil.deadline">{{cluedeatil.deadline}}</span>
                        <span v-else>--</span>
                    </div> -->
                </div>
                <div class="labelContainer">
                    <span class="title">标签展示：</span>
                    <div><span>有电话</span></div>

                    <a-dropdown class="labelclue" :trigger="['click']">
                        <a class="ant-dropdown-link" @click="e => e.preventDefault()"><a-icon type="edit" theme="filled"/> 编辑</a>
                        <div slot="overlay">
                            <a-checkbox-group
                            v-model="value"
                            name="checkboxgroup"
                            :options="plainOptions"
                            @change="onChange"
                            />

                            <div class="btnContent">
                                <a-button size="small" >取消</a-button>
                                <a-button size="small" type="primary">确定</a-button>
                            </div>
                        </div>
                    </a-dropdown>
                </div>

                <div class="btnListContainer">
                    <a-button @click="showgj" type="primary"><a-icon type="snippets" theme="filled"/>写跟进</a-button>
                    <a-button @click="editclue" :id="clueid" ><a-icon type="edit" theme="filled"/>编辑</a-button>
                    <a-button @click="showplan"><a-icon type="clock-circle"/>创建计划</a-button>
                    <a-button><a-icon type="phone" theme="filled"/>关联联系人</a-button>
                    <a-button @click="delclue"><a-icon type="delete"/>删除</a-button>
                </div>
            </div>
            <div class="lowerInfoContent">
                <a-tabs default-active-key="1" @change="callback">
                    <a-tab-pane key="1" tab="概况信息">
                        <div class="informationLeft">
                            <div class="basicinfo">
                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>基本信息</span>
                                </div>
                                <a-descriptions bordered :column="2">
                                    <a-descriptions-item v-for="(item,i) in system_field_list" :key="i" :label="item.name">{{cluedeatil[item.field_name]}}</a-descriptions-item>
                                </a-descriptions>
                            </div>
                        </div>
                        <div class="informationRight">
                            <div class="basicinfo">
                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>商机动态</span>
                                </div>

                                 <a-timeline v-if="gjrecord.length>0">
                                    <div v-for="(item,i) in gjrecord" :key="i">
                                        <a-timeline-item >
                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                            <div class="date-arrow">{{item.date}}</div>
                                        </a-timeline-item>
                                        <a-timeline-item>
                                            <div class="description">
                                                <div class="dataContainer">
                                                    <span class="follow-title">{{followtilte}}</span>
                                                    <span class="follow-date"><a-icon type="clock-circle"/>{{item.add_time}}</span>
                                                    <div>{{item.content}}</div> 
                                                    <!-- <div><p>接通状态：已接听</p></div>
                                                    <div><p>通话对象：万先生</p></div>
                                                    <div class="RecordingAudio"></div> -->

                                                    <div><p>来自线索：<a href="JavaScript:;">{{item.user_name}}</a></p></div>
                                                    <div class="cz-user"><p>操作人：<span>{{item.user_name}}</span></p></div>
                                                </div>
                                            </div>
                                        </a-timeline-item>
                                    </div>
                                    <!-- <a-timeline-item>Technical testing 2015-09-01</a-timeline-item>
                                    <a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item> -->
                                </a-timeline>

                                <a-empty v-else :image="simpleImage" />
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="2" tab="商机动态" force-render>
                        <div class="informationRight">
                            <div class="basicinfo">
                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>线索动态</span>
                                </div>

                                <div class="detail-stepsFilter">
                                    <div class="stepsFilter-list">
                                        <span v-for="(item,index) in stepList" :key="index" @click="addClass(index)" :class="index==current? 'isstep':''">{{item.title}}<a-divider type="vertical" /></span>
                                    </div>
                                </div>

                                <a-timeline>
                                    <div v-for="(item,i) in gjrecord" :key="i">
                                        <a-timeline-item >
                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                            <div class="date-arrow">{{item.date}}</div>
                                        </a-timeline-item>
                                        <a-timeline-item>
                                            <div class="description">
                                                <div class="dataContainer">
                                                    <span class="follow-title">{{followtilte}}</span>
                                                    <span class="follow-date"><a-icon type="clock-circle"/>{{item.add_time}}</span>
                                                    <div>{{item.content}}</div> 
                                                    <!-- <div><p>接通状态：已接听</p></div>
                                                    <div><p>通话对象：万先生</p></div>
                                                    <div class="RecordingAudio"></div> -->

                                                    <div><p>来自线索：<a href="JavaScript:;">{{item.user_name}}</a></p></div>
                                                    <div class="cz-user"><p>操作人：<span>{{item.user_name}}</span></p></div>
                                                </div>
                                            </div>
                                        </a-timeline-item>
                                    </div>

                                    
                                    <!-- <a-timeline-item>Technical testing 2015-09-01</a-timeline-item>
                                    <a-timeline-item>Network problems being solved 2015-09-01</a-timeline-item> -->
                                </a-timeline>
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="3" tab="资料详情">
                        <div class="informationLeft">
                            <div class="basicinfo">
                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>基本信息</span>
                                </div>
                                <a-descriptions bordered :column="2">
                                    <a-descriptions-item v-for="(item,i) in system_field_list" :key="i" :label="item.name">{{cluedeatil[item.field_name]}}</a-descriptions-item>
                                </a-descriptions>

                                <div class="title">
                                    <img src="../../../static/flag.png" alt="">
                                    <span>系统信息</span>
                                </div>
                                <a-descriptions bordered :column="2">
                                    <a-descriptions bordered :column="2">
                                    <a-descriptions-item v-for="(item,i) in system_field_list2" :key="i" :label="item.name">{{khdetail[item.field_name]}}</a-descriptions-item>
                                </a-descriptions>
                                </a-descriptions>
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="5" tab="相关联系人">
                         <div class="informationLeft">
                            <div class="basicinfo">
                                 <a-table bordered :columns="columns" :data-source="lxdata">
                                    <a slot="name" slot-scope="text">{{ text }}</a>
                                </a-table>
                            </div>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>

        <!-- 写跟进 -->
        <a-modal
        title="新建跟进"
        :visible="gjvisible"
        :confirm-loading="confirmLoading"
        @ok="gjhandleOk"
        @cancel="handleCancel"
        width="610px"
        okText="保存"
        >
            <div class="followLog">
               <a-textarea v-model="gjcontent" placeholder="勤跟进,多签单" :rows="2" />
            </div> 
        </a-modal>

         <!-- 变更所属人 -->
        <a-modal
        title="变更所属人"
        :visible="bgvisible"
        :confirm-loading="confirmLoading"
        @ok="bghandleOk"
        @cancel="handleCancel"
        width="510px"
        okText="保存"
        >
            <div class="bgLog">
                <a-row style="margin-bottom:20px">
                   <a-col :span="5" ><label for="">现有所属人：</label></a-col>
                   <a-col :span="16">
                        <span>程先生</span>
                   </a-col>
               </a-row>
                <a-row>
                   <a-col :span="5" ><label for="" class="required">指定所属人：</label></a-col>
                   <a-col :span="16">
                        <a-select style="width: 100%" @change="bghandleChange">
                            <a-select-option v-for="item in bglist" :key="item.id" :value="item.id">
                                {{item.name}}
                            </a-select-option>

                        </a-select>
                   </a-col>
               </a-row>
            </div> 
        </a-modal>

        
        <!-- 放弃 -->
        <a-modal
        title="放弃"
        :visible="fqvisible"
        :confirm-loading="confirmLoading"
        @ok="fqhandleOk"
        @cancel="handleCancel"
        width="520px"
        okText="确定"
        >
            <div class="fqLog">
               
               <a-row>
                   <a-col :span="5" ><label for="" class="required">放弃原因</label></a-col>
                   <a-col :span="16">
                        <a-select style="width: 100%" @change="fqreason">
                            <a-icon slot="suffixIcon" type="smile" />
                            <a-select-option v-for="(item,i) in reason" :key="i" :value="item">
                                {{item}}
                            </a-select-option>
                        </a-select>
                   </a-col>
               </a-row>
               <div style="margin: 24px 46px 0px 92px;">
                   <span>*放弃到公海后此客户数据将属于公共资源，原归属人员不能再维护跟进和更新此客户数据。</span>
               </div>
            </div> 
        </a-modal>

        <!-- 创建计划 -->
        <a-modal
        title="创建计划"
        :visible="planvisible"
        :confirm-loading="confirmLoading"
        @ok="planhandleOk"
        @cancel="handleCancel"
        width="480px"
        okText="保存"
        >
            <div class="planLog">
                <a-row>
                    <a-col  style="text-align:right;margin:0 0 24px" :span="6">
                        <label class="required" for="">计划开始时间：</label>
                    </a-col>
                    <a-col :span="18">
                        <a-date-picker
                            format="YYYY-MM-DD"
                            :disabled-date="disabledDate"
                        />
                    </a-col>
                    </a-row>
                    <a-row>
                    <a-col style="text-align:right" :span="6">
                        <label class="required"  for="">计划内容：</label>
                    </a-col>
                    <a-col :span="18">
                        <a-textarea placeholder="请输入" :rows="5" />
                    </a-col>
                </a-row>
            </div>
        </a-modal>
    </div>
</template>
<style>
.ant-dropdown-content{
    width: 140px;
    padding: 10px 12px 4px;box-sizing: border-box
}
.ant-dropdown{background: #fff;box-shadow: 0 2px 8px rgba(0,0,0,.15);}
.ant-dropdown-content .ant-checkbox-group label{
    margin-bottom: 6px;
    display: block;
    margin-right: 0;
    font-size: 13px;
}
.btnContent{
    height: 36px;
    text-align: center;
    border-top: 1px solid #ededed;
    padding: 8px 10px 0px ;
}
.btnContent button{font-size:12px}
</style>

<script>
import { Modal } from 'ant-design-vue';
import moment from 'moment';
const plainOptions = ['KA客户', '无效资源', '无合作意向'];
const columns = [
  {
    title: '联系人',
    dataIndex: 'contact_name',
    key: 'contact_name',
    scopedSlots: { customRender: 'contact_name' },
  },
  {
    title: '手机',
    dataIndex: 'mobile_phone',
    key: 'mobile_phone',
  },
  {
    title: '职务',
    dataIndex: 'role',
    key: 'role',
    ellipsis: true,
  },
];

const columns2 = [
  {
    title: '商机标题',
    dataIndex: 'name',
    key: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '预计成交金额(¥)',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: '预计成交时间',
    dataIndex: 'address',
    key: 'address 1',
    ellipsis: true,
  },
   {
    title: '销售阶段',
    dataIndex: 'jd',
    key: 'jd',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '阶段百分比',
    dataIndex: 'perect',
    key: 'perect',
  },
  {
    title: '意向产品',
    dataIndex: 'yx',
    key: 'yx 1',
    ellipsis: true,
  },
];
const data2 = [
  {
    key: '1',
    name: 'John Brown',
    age: 18759865674,
    address: 'New York No. 1 Lake Park, New York No. 1 Lake Park',
    tags: ['nice', 'developer'],
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 18759865674,
    address: 'London No. 2 Lake Park, London No. 2 Lake Park',
    tags: ['loser'],
  },
  {
    key: '3',
    name: 'Joe Black',
    age: 18759865674,
    address: 'Sidney No. 1 Lake Park, Sidney No. 1 Lake Park',
    tags: ['cool', 'teacher'],
  },
];
export default {
    data(){
        return{
            plainOptions,
            value: [],
            columns,
            columns2,
            data2,
            gjvisible:false,
            planvisible:false,
            fqvisible:false,
            bgvisible:false,
            confirmLoading:false,
            bglist:"",
            bgid:"",
            reason:"",
            cause_of_abandonment:"",
            gjcontent:"",
            clueid:"",
            system_field_list:"",
            system_field_list2:"",
            confirmLoading:false,
            lxdata:[],
            cluedeatil:{},

            stepList:[
                {title:'全部'},
                {title:'跟进记录'},
                {title:'跟进行为'},
                {title:'操作日志'}
            ],
            gjrecord:""

        }
    },
    mounted(){
        this.getfollow()

        this.clueid=this.$route.query.id

        // 商机详情
        this.$axios.get("/api/getbussnessdetail",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                id:this.clueid
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.cluedeatil=res.data.data.info
                this.lxdata=res.data.data.contact_info
            }else{
                this.$message.error(res.data.msg);
            }
        }),

             // 字段
        this.$axios.get('/api/bussnessfieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:1
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.system_field_list=data2
            }else{
                this.$message.warning(res.data.msg);
            }
        }),
        this.$axios.get('/api/bussnessfieldlist',{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                is_edit:2
            }
        }).then((res)=>{
            if(res.data.code==200){

                var data=res.data.data.field_list
                var data2=res.data.data.system_field_list
                for(var i in data){
                    data2.push(data[i])
                }
                this.system_field_list2=data2
            }else{
                this.$message.warning(res.data.msg);
            }
        }),

        this.$axios.get("/api/userlist",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.bglist=res.data.data.lists
            }
        }),

        // 放弃原因
        this.$axios.get("/api/dropreason",{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                this.reason=res.data.data
            }
        })

    },
    methods:{
        addClass(index){
            this.current=index
            if(index==1){
                this.getfollow()
                this.followtilte="写跟进"
            }
        },
        getfollow(){
            this.$axios.get("/api/followlist",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    bussness_id:this.$route.query.id
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.gjrecord=res.data.data
                }else{
                    this.$message.error(res.data.msg);
                }
            })

        },


        moment,
        change(){

        },
         // 编辑
        editclue(event){
            var id=event.currentTarget.id
            this.$router.push({path: '/editbusiness',query:{ id:id}});
        },

        disabledDate(current) {
            return current < moment().endOf('day');
        },
        bghandleChange(value){
            this.bgid=value
        },
        onChange(){

        },
        back(){
            this.$router.go(-1);//返回上一层
        },
        showgj(){
            this.gjvisible=true
        },
        showbg(){
            this.bgvisible=true
        },
        showplan(){
            this.planvisible=true
        },
        fqshow(){
            this.fqvisible=true
        },
        handleCancel(){
            this.gjvisible=false
            this.planvisible=false
            this.fqvisible=false
            this.bgvisible=false
        },
        // 跟进
        gjhandleOk(){
            this.$axios.get("/api/addfollow",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    content:this.gjcontent,
                    bussness_id:this.$route.query.id,
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.gjvisible=false
                    this.$message.success(res.data.msg); 
                    this.getfollow()

                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },
        // 计划
        planhandleOk(){

        },
        // 变更
        bghandleOk(){
            this.$axios.get("/api/setdatabelong",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    ids:this.$route.query.id,
                    kehu_id:this.bgid
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },
        // 放弃
        fqreason(value){
            this.cause_of_abandonment=value
        },
        fqhandleOk(){
            this.$axios.get("/api/dropdata",{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },
                params:{
                    ids:this.$route.query.id,
                    cause_of_abandonment:this.cause_of_abandonment
                }
            }).then((res)=>{
                if(res.data.code==200){
                   this.$message.success(res.data.msg); 
                }else{
                    this.$message.error(res.data.msg); 
                }
            })
        },
        // 删除
        delclue() {
            Modal.confirm({
                title: '提示',
                content: '您确定删除此菜单吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok()
                },
                onCancel() {

                },
            });
        },

        handok(){
            var params=new URLSearchParams()
            params.append('id',editid)
            this.$axios.post('/api/delmenu',params,{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
     
            })
        },

    }
}
</script>



// WEBPACK FOOTER //
// src/components/customer/busdetail.vue